(() => {
  if (!window.customElements || window.customElements.get('vg-detail-title')) return;

  class VillaGoDetailTitle extends HTMLElement {
    connectedCallback() {
      if (this.mounted) return;
      this.mounted = true;
      this.label = this.querySelector('span');
      this.frame = null;
      this.width = null;
      this.scheduleFit = () => {
        if (!this.mounted || this.frame !== null) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = null;
          if (this.mounted) this.fit();
        });
      };
      // Width changes matter; font fitting itself also changes the observed height.
      if (window.ResizeObserver) {
        this.observer = new window.ResizeObserver(([entry]) => {
          if (!this.mounted || entry.contentRect.width === this.width) return;
          this.width = entry.contentRect.width;
          this.scheduleFit();
        });
        this.observer.observe(this);
      }
      window.addEventListener('resize', this.scheduleFit);
      document.fonts?.addEventListener('loadingdone', this.scheduleFit);
      const schedule = this.scheduleFit;
      document.fonts?.ready.then(() => {
        if (this.mounted && this.scheduleFit === schedule) schedule();
      });
      this.fit();
    }

    fit() {
      const available = this.clientWidth - 1;
      const baseSize = parseFloat(window.getComputedStyle(this.parentElement).fontSize);
      if (!this.label || available <= 0 || !Number.isFinite(baseSize)) return;
      // Start from the heading size on every pass so resizing never compounds shrinkage.
      this.style.fontSize = `${baseSize}px`;
      this.classList.add('is-fitted');
      let size = baseSize;
      for (let pass = 0; pass < 3; pass += 1) {
        const width = this.label.getBoundingClientRect().width;
        if (width <= available || width <= 0) break;
        size = Math.max(1, Math.floor(size * available / width * 100) / 100);
        this.style.fontSize = `${size}px`;
      }
    }

    disconnectedCallback() {
      this.mounted = false;
      if (this.frame !== null) window.cancelAnimationFrame(this.frame);
      this.frame = null;
      this.observer?.disconnect();
      this.observer = null;
      window.removeEventListener('resize', this.scheduleFit);
      document.fonts?.removeEventListener('loadingdone', this.scheduleFit);
    }
  }

  window.customElements.define('vg-detail-title', VillaGoDetailTitle);
})();
